import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { handleStaleResponse } from "../lib/handle_stale_response";
import { autosaveDraft, cancel as cancelAutosave } from "../components/lib/autosave_draft";

export default class extends Controller {
  static targets = ["trigger", "triggerLabel", "checkButton"];
  static values = {
    checkUrl: String,
    draftUrl: String,
  };

  connect() {
    this.checking = false;
    this._refreshState();
    this._onDocClick = (event) => {
      this.triggerTargets.forEach((trigger) => {
        if (trigger.open && !trigger.contains(event.target)) trigger.open = false;
      });
    };
    document.addEventListener("click", this._onDocClick, true);
  }

  disconnect() {
    if (this._onDocClick) {
      document.removeEventListener("click", this._onDocClick, true);
      this._onDocClick = null;
    }
    if (this.hasDraftUrlValue) cancelAutosave(this.draftUrlValue);
  }

  pick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const value = button.dataset.option || "";
    const trigger = button.closest("[data-word-image-select-player-target='trigger']");
    if (!trigger) return;

    trigger.dataset.selection = value;
    const label = trigger.querySelector("[data-word-image-select-player-target='triggerLabel']");
    if (label) {
      label.textContent = value;
      label.classList.remove("text-content-muted");
    }
    trigger.removeAttribute("open");
    this._refreshState();
    this._scheduleAutosave();
  }

  _refreshState() {
    if (!this.hasCheckButtonTarget) return;
    const interactive = this.triggerTargets.filter((t) => !t.classList.contains("pointer-events-none"));
    const filledCount = interactive.filter((t) => (t.dataset.selection || "").length > 0).length;
    const allFilled = interactive.length > 0 && filledCount === interactive.length;
    this.checkButtonTarget.disabled = !allFilled || this.checking;
  }

  _currentSubmitted() {
    const submitted = {};
    this.triggerTargets.forEach((trigger) => {
      const id = trigger.dataset.itemId;
      if (id) submitted[id] = trigger.dataset.selection || "";
    });
    return submitted;
  }

  _scheduleAutosave() {
    if (this.checking || !this.hasDraftUrlValue) return;
    autosaveDraft({
      url: this.draftUrlValue,
      body: { submitted: this._currentSubmitted() },
    });
  }

  check(event) {
    event?.preventDefault();
    if (this.checking) return;
    if (this.checkButtonTarget.disabled) return;

    this.checking = true;
    this.checkButtonTarget.disabled = true;
    if (this.hasDraftUrlValue) cancelAutosave(this.draftUrlValue);

    const token = document.querySelector("meta[name=csrf-token]")?.content || "";
    const params = new URLSearchParams();
    this.triggerTargets.forEach((trigger) => {
      const id = trigger.dataset.itemId;
      const sel = trigger.dataset.selection || "";
      if (id) params.append(`submitted[${id}]`, sel);
    });

    fetch(this.checkUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token,
      },
      body: params.toString(),
    })
      .then((r) => {
        if (handleStaleResponse(this, r)) return null;
        return r.text();
      })
      .then((html) => {
        if (html) Turbo.renderStreamMessage(html);
      })
      .finally(() => {
        this.checking = false;
      });
  }
}
